import { MedChronUpdateStatus, type UpdateProgress } from '../store/schemas'

// Stage word plus, during EXTRACTING only, a live "N of M files" count from the polled progress
// (ENG-7004 — deliberate addition over Figma "toolbar/version" (8769:47380), which shows only the
// stage word). Extraction is the only per-file stage; PENDING/MERGING/FINALIZING have no
// meaningful denominator, so they keep the bare stage word.
export function activeStatusLabel(status: MedChronUpdateStatus, progress?: UpdateProgress): string {
  switch (status) {
    case MedChronUpdateStatus.PENDING:
      return 'Queued...'
    case MedChronUpdateStatus.EXTRACTING: {
      // progress is missing before the first poll lands, and files_total is 0 until the worker
      // claims the run — fall back to the bare stage word in both windows.
      if (!progress || progress.files_total <= 0) return 'Extracting...'
      const done = Math.min(Math.max(progress.files_extracted + progress.files_included + progress.files_failed, 0), progress.files_total)
      return `Extracting... ${done} of ${progress.files_total} ${progress.files_total === 1 ? 'file' : 'files'}`
    }
    case MedChronUpdateStatus.MERGING:
      return 'Merging...'
    case MedChronUpdateStatus.FINALIZING:
      return 'Finalizing...'
    default:
      return 'Updating...'
  }
}
